export const durationPickerStyles = {
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "16px",
  },
  dropdownContainer: {
    flex: 1,
  },
  label: {
    fontSize: "15px",
    marginBottom: "5px",
    fontWeight: "400",
    color: "#000",
  },

  // checkbox styles:
  checkboxContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  checkboxPressable: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: "10px",
  },
  checkboxText: {
    fontSize: "14px",
    marginLeft: "8px",
    fontWeight: "400",
    color: "#000",
  },
};
